/** Determines the type of the space's access, if internal to the Site/Building, or
 * through the Street
 */
var SpaceAccess;
(function (SpaceAccess) {
    SpaceAccess["Internal"] = "Internal";
    SpaceAccess["Street"] = "Street";
})(SpaceAccess || (SpaceAccess = {}));

export { SpaceAccess };
//# sourceMappingURL=space-access.js.map
